// extracted by mini-css-extract-plugin
export default {"badge":"FormatBadge_badge__N24oZ","from":"FormatBadge_from__DRmhw","to":"FormatBadge_to__+QX+7","neutral":"FormatBadge_neutral__qy9XU"};